import { taskApi } from 'api';

export const distributeDocumentsToApi = async (
  taskId: string,
  language: string,
  documentUids: string[],
  serviceAgreementId: string,
) => {
  return await taskApi.distributeDocuments({
    serviceAgreementUid: serviceAgreementId,
    distributeDocumentsRequest: { taskId, language, documentUids },
  });
};
